import React from "react";
import PriceForm from "../../Price/PriceForm";
import { BsArrowLeft } from "react-icons/bs";
import { BtnPrimary } from "../../../share/buttons/Btn";
import { BsArrowRight } from "react-icons/bs";

const CreateCourseCalculator = (props) => {
    const showBtn = false;

    return (
        <div>
            <div className="flex justify-center items-center mb-20">
                <h4 className="text-[2rem] mt-10 text-purple-dark font-bold">
                    محاسبه هزینه بوت کمپ
                </h4>
            </div>
            <PriceForm showBtn={showBtn} />
            <div className="flex  justify-between items-center mt-20">
                <div
                    className="w-[20%] py-[15px] px-[35px] flex border-purple-dark text-purple-dark border-[1px] text-[1.8rem] rounded-[1.5rem] justify-around items-center cursor-pointer"
                    onClick={props.prevStep}
                >
                    <BsArrowRight />
                    <span>مرحله قبل</span>
                </div>
                <div
                    className="w-[20%] py-[15px] px-[35px] flex border-purple-dark text-purple-dark border-[1px] text-[1.8rem] rounded-[1.5rem] justify-around items-center cursor-pointer"
                    onClick={props.nextStep}
                >
                    <span>ثبت و ادامه</span>
                    <BsArrowLeft />
                </div>
            </div>
        </div>
    );
};

export default CreateCourseCalculator;
